import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { useAsync } from 'react-use';
import { CacheImageDetection, DetectStatus } from "../util/cache-image-detection";
import { defaultFileIconUrl } from "../util/const";
import { loadImage } from "../util/load-image";
/**
 * 异步探测 icon url 和 缩略图
 */
export function useGetFileIconOrThumbnail(props) {
  var mimeType = props.mimeType,
    thumbnail = props.thumbnail,
    libIconUrl = props.libIconUrl,
    concatUrl = props.concatUrl;
  var state = useAsync( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var url, isThumbnail, isLoaded;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = libIconUrl;
          isThumbnail = !!thumbnail;
          if (!url) {
            _context.next = 6;
            break;
          }
          /**
           * 直接缓存design里面的资源, 之前是用嗅探来做这个缓存的，有点取巧
           */
          CacheImageDetection.set(url, DetectStatus.Success);
          _context.next = 16;
          break;
        case 6:
          _context.prev = 6;
          _context.next = 9;
          return loadImage(concatUrl);
        case 9:
          isLoaded = _context.sent;
          url = isLoaded ? concatUrl : defaultFileIconUrl;
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](6);
          url = defaultFileIconUrl;
        case 16:
          if (!isThumbnail) {
            _context.next = 26;
            break;
          }
          _context.prev = 17;
          _context.next = 20;
          return loadImage(thumbnail);
        case 20:
          isThumbnail = _context.sent;
          _context.next = 26;
          break;
        case 23:
          _context.prev = 23;
          _context.t1 = _context["catch"](17);
          isThumbnail = false;
        case 26:
          return _context.abrupt("return", {
            iconURL: url,
            isThumbnail: isThumbnail
          });
        case 27:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 13], [17, 23]]);
  })), [mimeType, thumbnail]);

  // 嗅探过程中 iconURL 要返回空
  if (state.loading || !state.value) {
    return {};
  }
  ;

  // 没有失败 且已经加载完的情况下 则返回 对应的 libIconUrl or concatUrl
  return _objectSpread({}, state.value);
}
//# sourceMappingURL=use-get-icon.js.map